import auth0 from 'auth0-js'
import authConfig from './auth-config.json'

export default class Authenticator {
  constructor() {
    this.auth0 = new auth0.WebAuth({
      domain: authConfig.domain,
      redirectUri: `${window.location.origin}/callback`,
      clientID: authConfig.clientId,
      responseType: 'token id_token',
      scope: 'openid profile email',
      audience: authConfig.audience
    })
  }

  login(options) {
    this.auth0.authorize(options)
  }

  logout(options) {
    this.auth0.logout(options)
  }

  resetPassword(email, onSuccess, onError) {
    this.auth0.changePassword(
      {
        connection: 'Username-Password-Authentication',
        email
      },
      (err, res) => {
        if (err) onError(err)
        else onSuccess(res)
      }
    )
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) reject(err)

        resolve(authResult)
      })
    })
  }
}
